import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    justify-content: center;
    align-items: center;
    text-align: left;
    position: relative;
    padding: 20px;
`;

export const Label = styled.div`
    padding-bottom: 5px;
    padding-top: 5px;
    display: flex;
    justify-content: space-between;
    font: normal normal 600 16px/20px Mangueira;
    color: #7f7f7f;
`;

export const SelectArea = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const SelectLabel = styled.div`
    font: normal normal 600 12px Mangueira;
    color: #000000;
`;

export const TextArea = styled.div`
    align-items: center;
    justify-content: center;
    padding-bottom: 10px;
    padding-top: 10px;
`;

export const ButtonArea = styled.div`
    padding-bottom: 10px;
    padding-top: 10px;
    display: flex;
    justify-content: center;
    flex-direction: row;
    align-items: center;
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;
